/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { Injectable } from "@jkhy/frontend-utils/di";
import { TmHttpClient } from "@treasury/core/http";
import { createSwaggerClient } from "../../utils/tm-swagger-client";

import { FiPermissionModelDto } from "../";
import { HttpClient, RequestParams } from "./http-client";

@Injectable()
export class FiPermissionClient {
  private readonly http: HttpClient;

  constructor(tmHttp: TmHttpClient) {
    this.http = createSwaggerClient(tmHttp, HttpClient);
  }

  /**
   * No description
   *
   * @tags FiPermission
   * @name FiPermissionGet
   * @summary Returns all the FI Parameters
   * @request GET:/fiPermission
   */
  fiPermissionGet = (params: RequestParams = {}) =>
    this.http.request<FiPermissionModelDto[], any>({
      path: `/fiPermission`,
      method: "GET",
      format: "json",
      ...params,
    });
}
